/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Identifies which group of numbers to analyze for hot/cold calculations.
 * Maps to fields in GameScoringSchema.numberInputRules.
 * @export
 */
export const NumberGroup = {
    _11184809: '11184809',
    PRIMARY_WINNING: 'PRIMARY_WINNING',
    PRIMARY_BONUS: 'PRIMARY_BONUS',
    SECONDARY_WINNING: 'SECONDARY_WINNING',
    SECONDARY_BONUS: 'SECONDARY_BONUS',
    unknown_default_open_api: '11184809'
} as const;
export type NumberGroup = typeof NumberGroup[keyof typeof NumberGroup];


export function instanceOfNumberGroup(value: any): boolean {
    for (const key in NumberGroup) {
        if (Object.prototype.hasOwnProperty.call(NumberGroup, key)) {
            if (NumberGroup[key as keyof typeof NumberGroup] === value) {
                return true;
            }
        }
    }
    return false;
}

export function NumberGroupFromJSON(json: any): NumberGroup {
    return NumberGroupFromJSONTyped(json, false);
}

export function NumberGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): NumberGroup {
    return json as NumberGroup;
}

export function NumberGroupToJSON(value?: NumberGroup | null): any {
    return value as any;
}

